import { useQuery } from '@apollo/client'
import { useState } from 'react'

import { useWorkspaceParam } from 'features/workspace/hooks/useWorkspaceParam'
import { fromDTO } from './api/mapper'
import { GET_GAM_SETUP_ORDERS } from './api/query'
import { GamSetupOrderSlice, UseGetGamSetupOrders } from './types'

export const useGetGamSetupOrders = (): UseGetGamSetupOrders => {
  const [gamSetupOrders, setGamSetupOrders] = useState<GamSetupOrderSlice[]>([])
  const { workspaceId } = useWorkspaceParam()

  const { loading } = useQuery(GET_GAM_SETUP_ORDERS, {
    onCompleted: ({ node: { gamSetupOrders } }) => {
      if (gamSetupOrders && gamSetupOrders.length > 0) {
        setGamSetupOrders(fromDTO(gamSetupOrders))
      }
    },
    variables: { workspaceId },
  })

  return { gamSetupOrders, loading }
}
